import constants from './constants'

const sendCaptcha = async (action) => {
  if (!action) {
    action=constants.captchaAction
  }

  if (constants.captchaKey && constants.captchaAction && window.grecaptcha) {
    if (constants.captchaIsEnterprise) {
      if (window.grecaptcha.enterprise){
        try {
          return await window.grecaptcha.enterprise.execute(constants.captchaKey, {action: action});
        } catch (e) {
          console.warn('Invalid captcha')
          return false
        }
      }else {
        console.warn('Invalid captcha key found!')
        return false
      }
    } else {
      try {
        return await window.grecaptcha.execute(constants.captchaKey, {
          action: constants.captchaAction,
        })
      } catch (e) {
        console.warn('Invalid captcha', e)
        return false
      }
    }
  } else {
    console.warn('No captcha key found!')
    return false
  }
}

export default sendCaptcha
